import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import { Button, Checkbox, Col, Flex, Form, Input, Row } from "antd";

export default function RenderCheckbox(props) {
	const {
		namePath = [],
		form_question_options = [],
		required = false,
		question = null,
		description = null,
		add_another = false,
	} = props;
	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	const [inputs, setInputs] = useState(add_another ? [{ id: 0 }] : []);

	const handleAddAnother = () => {
		setInputs((prev) => [...prev, { id: prev.length }]);
	};

	const renderCheckboxField = (fieldName) => (
		<Form.Item shouldUpdate noStyle>
			{({ getFieldValue }) => {
				let selectedValue = getFieldValue(fieldName);
				let findOther = form_question_options.find((x) => x.is_other)?.option;

				return (
					<Form.Item
						name={fieldName}
						rules={[
							{
								required: required ? true : false,
								message: "Please select at least one option",
							},
						]}
					>
						<Checkbox.Group>
							<Flex align="baseline" gap={5} vertical>
								{form_question_options.map((option, index) => (
									<Checkbox key={`${option.id}-${index}`} value={option.option}>
										<Flex align="center" gap={5}>
											{option.option}
											{option.is_other &&
											selectedValue &&
											selectedValue.includes(findOther) ? (
												<Form.Item name={`${fieldName}_other`} noStyle>
													<Input placeholder="Please specify" />
												</Form.Item>
											) : null}
										</Flex>
									</Checkbox>
								))}
							</Flex>
						</Checkbox.Group>
					</Form.Item>
				);
			}}
		</Form.Item>
	);

	// If add_another is enabled, render for each input set
	if (add_another) {
		return (
			<>
				{inputs.map((input, idx) => (
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={24}
						xl={24}
						key={`input_set_${input.id}`}
					>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								<div
									className="quill-output question"
									dangerouslySetInnerHTML={{
										__html: question,
									}}
								/>
								{description && (
									<div className="description">{description}</div>
								)}
							</Col>
						</Row>
						<Row>
							<Col xs={24} sm={24} md={24} lg={24} xl={24}>
								{renderCheckboxField(`${newNamePath}_set_${idx}`)}
							</Col>
						</Row>
					</Col>
				))}

				<Col xs={24} sm={24} md={24} lg={24} xl={24}>
					<Button
						type="link"
						className="w-auto h-auto p-0"
						icon={<FontAwesomeIcon icon={faPlus} />}
						onClick={handleAddAnother}
					>
						Add Another
					</Button>
				</Col>
			</>
		);
	}

	return (
		<Row>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<div
					className="quill-output question"
					dangerouslySetInnerHTML={{
						__html: question,
					}}
				/>
				{description && <div className="description">{description}</div>}
			</Col>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				{renderCheckboxField(newNamePath)}
			</Col>
		</Row>
	);
}
